import React, { useState } from 'react';
import './FloatingFeedbackButton.css';

function FloatingFeedbackButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open('https://forms.gle/wLgED5qexbvrnbpx9', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="floating-feedback-wrapper">
      <button
        className={`floating-feedback-btn ${isHovered ? 'hovered' : ''}`}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="페이지 개선 제안하기"
      >
        <svg
          className="feedback-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          <line x1="9" y1="10" x2="15" y2="10"></line>
          <line x1="12" y1="7" x2="12" y2="13"></line>
        </svg>
        <span className="feedback-text">개선 요청</span>
      </button>

      {isHovered && (
        <div className="feedback-tooltip">
          페이지 변경 요청 사항을<br />
          남겨주세요!
        </div>
      )}
    </div>
  );
}

export default FloatingFeedbackButton;
